<template>
  <div>
    <div class="tile is-ancestor">
      <div class="tile is-4 is-parent">
        <article class="tile is-child box">
          <h3 class="title">待处理订单</h3>
          <h4>第三方待支付订单数:&nbsp;&nbsp;
            <strong class="red-color">
              <!--<span>{{thirdPartyRealTimeData.thirdPartyNotPaidOrderCount}}</span>-->
              <a href="/adminv/#!/thirdGoods/orderList?thirdPartyStatus=1">{{thirdPartyRealTimeData.thirdPartyNotPaidOrderCount}}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <h4>第三方待确认收货订单数:&nbsp;&nbsp;
            <strong class="red-color">
              <!--<span>{{thirdPartyRealTimeData.thirdPartyNotReceivedCount}}</span>-->
              <a href="/adminv/#!/thirdGoods/orderList?status=256&thirdPartyStatus=4">{{thirdPartyRealTimeData.thirdPartyNotReceivedCount}}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <h4 class="margin-bottom">第三方待评价数:&nbsp;&nbsp;
            <strong class="red-color">
              <!--<span>{{thirdPartyRealTimeData.thirdPartyWaitCommentCount}}</span>-->
              <a href="/adminv/#!/thirdGoods/orderList?thirdPartyStatus=256">{{thirdPartyRealTimeData.thirdPartyWaitCommentCount}}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <h4>第三方48小时未发货订单数:&nbsp;&nbsp;
            <strong class="red-color">
              <!--<span>{{thirdPartyRealTimeData.thirdPartyTimeoutShippingCount}}</span>-->
              <a href="/adminv/#!/thirdGoods/orderList?thirdPartyErrorStatus=4">{{thirdPartyRealTimeData.thirdPartyTimeoutShippingCount}}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <h4>穿衣超过34小时未发货数:&nbsp;&nbsp;
            <strong class="red-color">
              <!--<span>{{thirdPartyRealTimeData.thirdParty34HourTimeoutShippingCount}}</span>-->
              <a href="/adminv/#!/thirdGoods/orderList?status=2&thirdPartyErrorStatus=12">{{thirdPartyRealTimeData.thirdParty34HourTimeoutShippingCount}}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <h4 class="margin-bottom">订单状态更新失败数:&nbsp;&nbsp;
            <strong class="red-color">
              <!--<span>{{thirdPartyRealTimeData.thirdPartyManualRefreshFailedCount}}</span>-->
              <a href="/adminv/#!/thirdGoods/orderList?thirdPartyErrorStatus=8">{{thirdPartyRealTimeData.thirdPartyManualRefreshFailedCount}}</a>
            </strong>&nbsp;&nbsp;个
          </h4>


          <h4>第三方待处理退款退货订单数:&nbsp;&nbsp;
            <strong class="red-color">
              <!--<span>{{thirdPartyRealTimeData.thirdPartyNotDealRefundOrderCount}}</span>-->
              <a href="/adminv/#!/thirdGoods/refundList?refundStatus=1">{{thirdPartyRealTimeData.thirdPartyNotDealRefundOrderCount}}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <h4>第三方不同意退款:&nbsp;&nbsp;
            <strong class="red-color">
              <!--<span>{{thirdPartyRealTimeData.thirdPartyDisagreeRefundOrderCount}}</span>-->
              <a href="/adminv/#!/thirdGoods/refundList?thirdPartyRefundStatus=256">{{thirdPartyRealTimeData.thirdPartyDisagreeRefundOrderCount}}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <!--refundStatus为1和2的或关系-->
          <h4>待同步退货地址:&nbsp;&nbsp;
            <strong class="red-color">
              <!--<span>{{thirdPartyRealTimeData.thirdPartyWaitSyncReturnAddressCount }}</span>-->
              <a href="/adminv/#!/thirdGoods/refundList?refundStatus=2&thirdPartyRefundStatus=4">{{thirdPartyRealTimeData.thirdPartyWaitSyncReturnAddressCount }}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <h4>待编辑退货地址:&nbsp;&nbsp;
            <strong class="red-color">
              <a href="/adminv/#!/thirdGoods/refundList?refundStatus=3&thirdPartyRefundStatus=4">{{dealRefundAddressCount}}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <h4>用户已给运单号:&nbsp;&nbsp;
            <strong class="red-color">
              <a href="/adminv/#!/thirdGoods/refundList?refundStatus=1040">{{thirdPartyRealTimeData.thirdPartyWaitDeliveryCount  }}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <h4>待填写运单号:&nbsp;&nbsp;
            <strong class="red-color">
              <a href="/adminv/#!/thirdGoods/refundList?refundStatus=1024">{{thirdPartyRealTimeData.thirdPartyWaitFillReturnShipNumberCount  }}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <h4>待淘宝收货确认:&nbsp;&nbsp;
            <strong class="red-color">
              <a href="/adminv/#!/thirdGoods/refundList?refundStatus=16">{{thirdPartyRealTimeData.thirdPartyWaitConfirmDeliveryCount  }}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <!--20170301需求：去掉这两个状态，暂注释-->
          <!--<h4>第三方同意退款:&nbsp;&nbsp;-->
            <!--<strong class="red-color">-->
              <!--<a v-link="{ name: 'refundList', query: { thirdPartyRefundStatus:4}}">{{thirdPartyRealTimeData.thirdPartyAcceptRefundOrderCount}}</a>-->
            <!--</strong>&nbsp;&nbsp;个-->
          <!--</h4>-->
          <!--<h4>第三方驳回退款:&nbsp;&nbsp;-->
            <!--<strong class="red-color">-->
              <!--<a v-link="{ name: 'refundList', query: { thirdPartyRefundStatus:256}}">{{thirdPartyRealTimeData.thirdPartyRejectRefundOrderCount}}</a>-->
            <!--</strong>&nbsp;&nbsp;个-->
          <!--</h4>-->
        </article>
      </div>
      <div class="tile is-4 is-parent">
        <article class="tile is-child box">
          <h3 class="title">异常订单</h3>
          <h4>地址修改失败数:&nbsp;&nbsp;
            <strong class="red-color">
              <a href="/adminv/#!/thirdGoods/orderList?thirdPartyErrorStatus=2">{{thirdPartyRealTimeData.thirdPartyAddressFailedCount}}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <h4>穿衣地址转化为第三方地址失败数:&nbsp;&nbsp;
            <strong class="red-color">
              <a href="/adminv/#!/thirdGoods/orderList?thirdPartyErrorStatus=6">{{thirdPartyRealTimeData.thirdPartyAddressChangeErrorCount}}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <h4>第三方订单异常关闭:&nbsp;&nbsp;
            <strong class="red-color">
              <a href="/adminv/#!/thirdGoods/orderList?thirdPartyErrorStatus=7">{{thirdPartyRealTimeData.thirdPartyErrorClosedCount}}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <h4>登录失败数:&nbsp;&nbsp;
            <strong class="red-color">
              <a href="/adminv/#!/thirdGoods/orderList?thirdPartyErrorStatus=1">{{thirdPartyRealTimeData.thirdPartyLoginFailedCount}}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <h4>第三方下单失败数:&nbsp;&nbsp;
            <strong class="red-color">
              <a href="/adminv/#!/thirdGoods/orderList?thirdPartyErrorStatus=3">{{thirdPartyRealTimeData.thirdPartyOrderFailedCount}}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <h4>穿衣售价低于第三方商品售价订单数:&nbsp;&nbsp;
            <strong class="red-color">
              <a href="/adminv/#!/thirdGoods/orderList?thirdPartyErrorStatus=9">{{thirdPartyRealTimeData.thirdPartyLossOrderCount}}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <h4>解析第三方订单ID失败:&nbsp;&nbsp;
            <strong class="red-color">
              <a href="/adminv/#!/thirdGoods/orderList?thirdPartyErrorStatus=10">{{thirdPartyRealTimeData.thirdPartyParseOrderIdErrorCount}}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
          <h4>第三方需要手动绑定订单数:&nbsp;&nbsp;
            <strong class="red-color">
              <a href="/adminv/#!/thirdGoods/orderList?status=2&thirdPartyOrderId=-1">{{thirdPartyRealTimeData.thirdPartyManualOrderCount}}</a>
            </strong>&nbsp;&nbsp;个
          </h4>
        </article>
      </div>
      <div class="tile is-4 is-parent">
      <article class="tile is-child box">
        <h3 class="title">商品监控</h3>
        <h4>昨日上新商品数:&nbsp;&nbsp;
          <strong class="red-color">
            <a href="/adminv/#!/thirdGoods/goodsList?endSellTime=2017-10-30&startSellTime=2017-10-30">{{thirdPartyRealTimeData.thirdPartyYesterdayOnlineGoodsCount}}</a>
          </strong>&nbsp;&nbsp;个
        </h4>
        <h4>库存较低商品数:&nbsp;&nbsp;
          <strong class="red-color">
            <a href="/adminv/#!/thirdGoods/goodsList?isStockAlert=1">{{thirdPartyRealTimeData.thirdPartyLowStockGoodsCount}}</a>
          </strong>&nbsp;&nbsp;个
        </h4>
        <h4>近30天下架商品数:&nbsp;&nbsp;
          <strong class="red-color">
            <a href="/adminv/#!/thirdGoods/goodsList?isMonthSoldOut=1&isSoldOut=1">{{thirdPartyRealTimeData.thirdPartySoldOutGoodsCount}}</a>
          </strong>&nbsp;&nbsp;个
        </h4>
        <h4>穿衣售价低于第三方商品售价商品数:&nbsp;&nbsp;
          <strong class="red-color">
            <a href="/adminv/#!/thirdGoods/goodsList?isLoss=1&isSoldOut=0">{{thirdPartyRealTimeData.thirdPartyLossGoodsCount}}</a>
          </strong>&nbsp;&nbsp;个
        </h4>
        <h4>在售商品数:&nbsp;&nbsp;
          <strong class="red-color">
            <a href="/adminv/#!/thirdGoods/goodsList?thirdPartyGoodsIsSoldOut=0">{{thirdPartyRealTimeData.thirdPartyOnSaleGoodsCount}}</a>
          </strong>&nbsp;&nbsp;个
        </h4>
        <h4>在售无淘客商品数:&nbsp;&nbsp;
          <strong class="red-color">
            <a href="/adminv/#!/thirdGoods/goodsList?isTaobaoke=0&thirdPartyGoodsIsSoldOut=0">{{thirdPartyRealTimeData.thirdPartyOnSaleNoTaobaokeGoodsCount}}</a>
          </strong>&nbsp;&nbsp;个
        </h4>
        <h4>昨日有销量无淘宝客商品数:&nbsp;&nbsp;
          <strong class="red-color">
            <a href="/adminv/#!/thirdGoods/goodsList?isTaobaoke=0&isYesterdayHadSell=1">{{thirdPartyRealTimeData.yesterdayHadSellNoTaobaokeGoodsCount}}</a>
          </strong>&nbsp;&nbsp;个
        </h4>
      </article>
    </div>

    </div>

  </div>
</template>

<script type="text/babel">
 import { getPreDate } from 'UTILS/date.js';
export default {
  data () {
    return {
      yesterday:"",
      thirdPartyRealTimeData:{},
      dealRefundAddressCount:0
    }
  },
  mounted() {
    this.init();
  },
  methods:{
    init() {
      var ysArray = getPreDate(1);
      this.yesterday = ysArray;
      this.getRealTimeData();
      this.getWaitDealRefundAddressCount();
    },
    getRealTimeData(){
      HttpRequest.get('/admin.php?method=shoppingguide.getRealTimeData').then((response) => {
        // 字段异常处理
        for(let i in response.data){
          if(response.data[i] === null){
            response.data[i] = 0
          }
        }
        this.thirdPartyRealTimeData = Object.assign({}, this.thirdPartyRealTimeData, response.data);
      });
    },
    getWaitDealRefundAddressCount(){
      HttpRequest.get('/admin.php?method=shoppingguide.getWaitDealRefundAddressCount').then(response => {
        this.dealRefundAddressCount = response.data;
      })
    }
  }
}
</script>

<style rel="stylesheet/less" lang="less" scoped>
  .red-color{
    a{
      color:red;
    }
  }
  .margin-bottom{
    margin-bottom: 20px;
  }
</style>
